import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import TcImage from './TcImage';
import imageScanQrBtn from '../assets/images/btn_scan-qr.png';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { openScanner } from '../store/slices/navigationSlice';
import TcPopupR65 from './TcPopupR65';
import TcButton from './TcButton';
import { useNavigate } from 'react-router-dom';

const TcScanQrBtn = ({ 
    classNameStyle = ""
}: {
    classNameStyle?: string;
}) => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();
    const visitorId = useAppSelector((state) => state.user.visitorId);
    const currentPage = useAppSelector((state) => state.navigation.previousRoute);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const navigate = useNavigate();

    const handleClosePopup = () => {
        setIsPopupOpen(false);
    };

    const handleClick = () => {
        // Check whether the current page is Home page, if so, show the QR scanner modal, if not, check if the user is registered
        if (currentPage === '/') {
            dispatch(openScanner());
        } else {
            // Check if the user is registered
            if (visitorId) {
                // If the user is registered, show the QR scanner modal
                dispatch(openScanner());
            } else {
                // If the user is not registered, show the Register Now popup
                // setIsPopupOpen(true);
                dispatch(openScanner());  // regardless of registered or not, open the scanner modal
            }
        }
    };
    
    return (
        <>
        <div className={`tc-scan-qr-btn rounded-full shadow-[0_4px_20px_0_#1a1a1a] ${classNameStyle}`}>
            <TcImage 
                classNameStyle="!w-[80px] !h-[80px]"
                handleClick={handleClick}
            >
                <img 
                    src={imageScanQrBtn} 
                    alt={t('layout.scanQrCode')}
                    className="w-full"
                />
            </TcImage> 
        </div>

        {/* No personalization popup - register now button */}
            {isPopupOpen && (
                <div className={`fixed top-0 bottom-0 left-0 right-0 z-[15] ${isPopupOpen ? 'opacity-100' : 'opacity-0'} has-transition`}>
                    <TcPopupR65
                        handleClose={handleClosePopup}
                    >
                        <div className='flex flex-col items-center justify-center mt-2 mb-4'>
                            <p className='leading-tight'>{t('exhibitShared.noPersonalizationMessage4')}</p>
                            <TcButton
                                handleClick={() => navigate('/register')}
                                classNameStyle={`!text-neutral-950 border-neutral-950`}
                                hollow
                            >
                                {t('exhibitShared.registerNow')}
                            </TcButton>
                        </div>
                    </TcPopupR65>
                </div>
            )}
        </>
    )
}

export default TcScanQrBtn;